"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toArray2 = require("babel-runtime/helpers/toArray");

var _toArray3 = _interopRequireDefault(_toArray2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _dispatcher = require("../../dispatcher");

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _languageHandler = require("../../languageHandler");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var ToastContainer = function (_React$Component) {
    (0, _inherits3.default)(ToastContainer, _React$Component);

    function ToastContainer() {
        (0, _classCallCheck3.default)(this, ToastContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ToastContainer.__proto__ || (0, _getPrototypeOf2.default)(ToastContainer)).call(this));

        _this.onAction = function (payload) {
            if (payload.action === "show_toast") {
                _this._addToast(payload.toast);
            }
        };

        _this.dismissTopToast = function () {
            var _this$state$toasts = (0, _toArray3.default)(_this.state.toasts),
                remaining = _this$state$toasts.slice(1);

            _this.setState({ toasts: remaining });
        };

        _this.state = { toasts: [] };
        return _this;
    }

    (0, _createClass3.default)(ToastContainer, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this._dispatcherRef = _dispatcher2.default.register(this.onAction);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            _dispatcher2.default.unregister(this._dispatcherRef);
        }
    }, {
        key: "_addToast",
        value: function _addToast(toast) {
            this.setState({ toasts: this.state.toasts.concat(toast) });
        }
    }, {
        key: "render",
        value: function render() {
            var totalCount = this.state.toasts.length;
            var isStacked = totalCount > 1;
            var toast = void 0;
            if (totalCount !== 0) {
                var topToast = this.state.toasts[0];
                var title = topToast.title,
                    icon = topToast.icon,
                    key = topToast.key,
                    component = topToast.component,
                    props = topToast.props;

                var toastClasses = (0, _classnames2.default)("mx_Toast_toast", (0, _defineProperty3.default)({
                    "mx_Toast_hasIcon": icon
                }, "mx_Toast_icon_" + icon, icon));
                var countIndicator = isStacked ? (0, _languageHandler._t)(" (1/%(totalCount)s)", { totalCount: totalCount }) : null;

                var toastProps = (0, _assign2.default)({}, props, {
                    dismiss: this.dismissTopToast,
                    key: key
                });
                toast = React.createElement(
                    "div",
                    { className: toastClasses },
                    React.createElement(
                        "h2",
                        null,
                        title,
                        countIndicator
                    ),
                    React.createElement(
                        "div",
                        { className: "mx_Toast_body" },
                        React.createElement(component, toastProps)
                    )
                );
            }

            var containerClasses = (0, _classnames2.default)("mx_ToastContainer", {
                "mx_ToastContainer_stacked": isStacked
            });

            return React.createElement(
                "div",
                { className: containerClasses, role: "alert" },
                toast
            );
        }
    }]);
    return ToastContainer;
}(React.Component);

exports.default = ToastContainer;
module.exports = exports["default"];
//# sourceMappingURL=ToastContainer.js.map